"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSProcessor = void 0;
var _CSSInlineParseRun = require("./CSSInlineParseRun");
var _CSSNativeParseRun = require("./CSSNativeParseRun");
var _CSSPropertiesValidationRegistry = require("./CSSPropertiesValidationRegistry");
var _default = require("./default");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var CSSProcessor = /*#__PURE__*/function () {
  function CSSProcessor(userConfig) {
    _classCallCheck(this, CSSProcessor);
    _defineProperty(this, "registry", void 0);
    var config = _objectSpread(_objectSpread({}, _default.defaultCSSProcessorConfig), userConfig);
    this.registry = new _CSSPropertiesValidationRegistry.CSSPropertiesValidationRegistry(config);
  }
  /**
   *
   * Incoming style declaration:
   * - For native styles: any RN compatible style declaration + special units
   *   (font-size: medium) + relative units (smaller, larger, em, rem and perhaps vw)
   *
   * @param declaration
   */
  _createClass(CSSProcessor, [{
    key: "compileStyleDeclaration",
    value: function compileStyleDeclaration(declaration) {
      var parseRun = new _CSSNativeParseRun.CSSNativeParseRun(declaration, this.registry);
      return parseRun.exec();
    }
  }, {
    key: "compileInlineCSS",
    value: function compileInlineCSS(inlineCSS) {
      var parseRun = new _CSSInlineParseRun.CSSInlineParseRun(inlineCSS, this.registry);
      return parseRun.exec();
    }
  }]);
  return CSSProcessor;
}();
exports.CSSProcessor = CSSProcessor;